import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import fatcaQuestionnaireType from '../../life-config/fatcaQuestionConfig.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import { CountryInfo, CompanyInfo } from '../../model/data.model';
import documentUploadFormJson from '../../life-config/documentUploadConfig.json';


@Component({
    selector: 'app-fatca',
    templateUrl: './fatca.component.html',
    styleUrls: ['./fatca.component.css']
})
export class FatcaComponent implements OnInit {

    fatcaQuestionnaireForm: FormGroup;
    addFatcaDetails: FormArray;
    fatcaQuestionnaireDetails: object = fatcaQuestionnaireType.FatcaQuestionnaireFormInitialJson;
    covidQuestionnaireDetails: object = fatcaQuestionnaireType.covidQuestion;
    defenceQuestionnaireDetails: object = fatcaQuestionnaireType.defenceQuestion;
    occupationQuestionnaireDetails: object = fatcaQuestionnaireType.occupationQuestion;
    documentUploadDataJson: any = documentUploadFormJson.documentUplodJson;
    apiUrl: object = apiUrlPoint.apiEndPoints;

    filteredCompanyName: Observable<any[]>;

    birthCountryList: any;
    citizenCountryList: any;
    companyList: any;
    addressCountryList: any;
    taxResidencyCountry: any;
    addressStateList: any;
    addResidencyState: any;
    addressCityList: any;
    addressPincode: any;
    mergedCovidData: any;
    defenceData: any;
    occupdationData: any;
    proposalRes: any;
    fatcaData: any;
    finalDataToSend: any;
    dataToSend: any;
    tabListData: any;
    fatcaAsPerApi: any;
    previousPolicyData: any;
    finalvalToSend: Array<any> = [];
    additonalFatcaArr = [];
    // residence_tax : any;

    uuid: string;
    proposalId: string;
    productType: object = lifeProductType.product_type;
    isLeftSectionLoader = false;
    isLoaderActivated = false;
    docProposalRes: any;
    fatcaOccupation: any;
    occupationList: any;

    constructor(
        private apiService: ApiService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private datePipe: DatePipe,
        private sharedData: SharedApiService,
        private formbuild: FormBuilder) {

        this.fatcaQuestionnaireForm = this.formbuild.group({
            birthPlace : ['', [
                Validators.required,
                Validators.maxLength(20),
                Validators.pattern(new RegExp('^[a-zA-Z0-9]*$'))
            ]],
            birthCountry : ['', [Validators.required]],
            citizenCountry: [''],
            identificationDoc: [''],
            identificationNumber: [''],
            disbaleIdentificationNumber:[''],
            fatcaOccupation:[''],
            disbaleIdentificationDoc:[''],
            companyName: ['', [Validators.required, Validators.maxLength(50)]],
            addressCountry : [''],
            currentAddressLine1: ['', [
                Validators.required,
                Validators.maxLength(30),
                // tslint:disable-next-line: quotemark
                Validators.pattern(new RegExp("^[a-zA-Z0-9 ,./:()\\'`-]+$"))]],
            // tslint:disable-next-line: max-line-length
            currentAddressLine2: ['', [
                Validators.required,
                Validators.maxLength(30),
                // tslint:disable-next-line: quotemark
                Validators.pattern(new RegExp("^[a-zA-Z0-9 ,./:()\\'`-]+$"))]],
            currentAddCountry: ['', [Validators.required]],
            currentAddState : ['', [
                Validators.required,
                Validators.pattern(new RegExp('^[a-zA-Z0-9]+$')),
                Validators.minLength(2),
                Validators.maxLength(25)] ],
            currentAddCity : ['', [
                Validators.required,
                Validators.pattern(new RegExp('^[a-zA-Z0-9]+$')),
                Validators.minLength(2),
                Validators.maxLength(25)] ],
            currentAddPincode : ['', [
                Validators.required,
                Validators.maxLength(25)] ],
            addTaxResidency: [''],
            addStateTaxResidency : ['' ],
            mobileNo: ['', [
                Validators.required,
                Validators.minLength(2),
                Validators.maxLength(25),
                // tslint:disable-next-line: quotemark
                Validators.pattern(new RegExp("^[0-9+]+$"))]],
            // residenceTax: [this.fatcaQuestionnaireDetails['residence_tax']['default']],
            addFatcaDetails : new FormArray([this.createPrvInsCtrl()])
            // addCountryTaxResidency: [''],
            // jurisdictionTaxAddress: [''],
            // taxIdentificationEquivalent: [''],
            // numberIssueTINCountry: [''],
            // documentValidity: [''],


        });

        this.apiService.getStatusEvent.subscribe(value => {

            if (value) {
                const errorStatusFromApi = value['status'];

                if ( errorStatusFromApi === 400 ) {

                    this.isLoaderActivated = false;
                }
            }


        });
        /**
         * Subscribe tabevent data
         */

        this.sharedData.tabEventData.subscribe(value => {
            if (value) {

                this.tabListData = value;


            }
        });
    }


    /**
     * Feed proposal data
     */

    feedProposalData() {

        /**
         * get tab Data
         */

        this.tabListData = this.sharedData.storeTabInfo();

        /**
         * set data
         */

        if(this.proposalRes['lifeassured']['occupation'])  {
            this.occupationList.forEach(occElement => {
                
                if(occElement['id'] ===this.proposalRes['lifeassured']['occupation'] ) {
                    this.fatcaQuestionnaireForm.patchValue(
                        { fatcaOccupation : occElement['master_name'] });
                }
                this.fatcaQuestionnaireForm.get('fatcaOccupation').disable();
            });
           

            
        }
        

        if (this.proposalRes['lifeassured']['fatca_detail'] ) {

            if (this.proposalRes['lifeassured']['fatca_detail']['place_of_birth']) {

                this.fatcaQuestionnaireForm.patchValue({birthPlace : this.proposalRes['lifeassured']['fatca_detail']['place_of_birth'] });
            }
            if (this.proposalRes['lifeassured']['fatca_detail']['birth_country'] ) {

                this.fatcaQuestionnaireForm.patchValue({birthCountry : this.proposalRes['lifeassured']['fatca_detail']['birth_country'] });
            }
            if (this.proposalRes['lifeassured']['fatca_detail']['company_name']) {

                this.fatcaQuestionnaireForm.patchValue({companyName : this.proposalRes['lifeassured']['fatca_detail']['company_name'] });
            }
            if (this.proposalRes['lifeassured']['fatca_detail']['country_of_citizenship']) {

                this.fatcaQuestionnaireForm.patchValue(
                    {citizenCountry : this.proposalRes['lifeassured']['fatca_detail']['country_of_citizenship'] });
            }

            

            
            this.fatcaQuestionnaireForm.patchValue(
                {currentAddressLine1 : this.proposalRes['lifeassured']['fatca_detail']['foreign_address_read_only']['line_1'] });
            this.fatcaQuestionnaireForm.patchValue(
                    {
                        currentAddressLine1 : this.proposalRes['lifeassured']['fatca_detail']['foreign_address_read_only']['line_1']
                    });
            this.fatcaQuestionnaireForm.patchValue(
                    {currentAddressLine2 : this.proposalRes['lifeassured']['fatca_detail']['foreign_address_read_only']['line_2'] });

            this.fatcaQuestionnaireForm.patchValue(
                        {currentAddCountry : this.proposalRes['lifeassured']['fatca_detail']['foreign_address_read_only']['country_id'] });

            this.fatcaQuestionnaireForm.patchValue(
                        {currentAddCity : this.proposalRes['lifeassured']['fatca_detail']['foreign_address_read_only']['city'] });

            this.fatcaQuestionnaireForm.patchValue(
                            {currentAddState : this.proposalRes['lifeassured']['fatca_detail']['foreign_address_read_only']['state'] });

            this.fatcaQuestionnaireForm.patchValue(
                    {currentAddPincode : this.proposalRes['lifeassured']['fatca_detail']['foreign_address_read_only']['pincode_id'] });

            this.fatcaQuestionnaireForm.patchValue(
                    { mobileNo : this.proposalRes['lifeassured']['fatca_detail']['mobile'] });

            /**
             * check for extra fatca details
             */

            if (this.proposalRes['lifeassured']['fatca_taxable_country_detail'].length > 0) {

                for (let i = 0; i < this.proposalRes['lifeassured']['fatca_taxable_country_detail'].length - 1; i++) {

                    this.additionalFatcaDetails();
                }

                this.previousPolicyData = this.proposalRes['lifeassured']['fatca_taxable_country_detail'];

                this.proposalRes['lifeassured']['fatca_taxable_country_detail'].forEach((element, index) => {



                    const exisitingFatcaElement = {
                        id : element.id,
                        addCountryTaxResidency: element.country,
                        taxIdentificationEquivalent: element.tin_number,
                        numberIssueTINCountry: element.tin_country,
                        documentValidity: element.tin_validity,
                        buildingName: element['address_read_only']['building_name'],
                        streetName: element['address_read_only']['street_name'],
                        cityName: element['address_read_only']['city'],
                        stateName: element['address_read_only']['state'],
                        fatcaPincode: element['address_read_only']['pincode']
                    };

                    if ( this.fatcaQuestionnaireForm.get('addFatcaDetails').get(index.toString())) {

                        this.fatcaQuestionnaireForm.get('addFatcaDetails').get(index.toString()).patchValue(exisitingFatcaElement);
                    }

                });



            }
            
        }

        /**
         * 
         */

        if(  this.docProposalRes.length > 0) {

            this.docProposalRes.forEach(element => {
                if(element['proof_type'] === 3) {

                    this.documentUploadDataJson['docTypeData']['docTypeList']['identity_proof'].forEach(jsonElement => {
                        
                        if(element['doc_type'] === jsonElement['value']) {

                            this.fatcaQuestionnaireForm.patchValue(
                                { disbaleIdentificationDoc : jsonElement['name'] });
                            this.fatcaQuestionnaireForm.get('disbaleIdentificationDoc').disable();
                            this.fatcaQuestionnaireForm.patchValue(
                                { disbaleIdentificationNumber : element['doc_number'] });
                            this.fatcaQuestionnaireForm.get('disbaleIdentificationNumber').disable();
                        };   

                    });
                }

            });

        }

        this.isLeftSectionLoader = false;
    }



  // Country List

    getCountryList() {
        this.apiService.getUtilsInfoWithoutInsurerQuery(this.apiUrl['getUtilsInfo'], this.apiUrl['country']).subscribe(res => {

            this.birthCountryList = res['country'];
            this.citizenCountryList = res['country'];
            this.addressCountryList = res['country'];
            this.taxResidencyCountry = res['country'];


        });
    }

    // Compnay

    // On country change - state will be selected
    onCountryChange(value: any, eventFrom: number) {
        if (value) {
            // tslint:disable-next-line: max-line-length
            this.apiService.getUtilsInfoWithPrvID(this.apiUrl['getUtilsInfo'], this.apiUrl['state'], this.apiUrl['country'], value).subscribe(res => {

                if (eventFrom === 1) {
                    this.addressStateList = res['state'];

                }


                if (eventFrom === 2) {

                    this.addResidencyState = res['state'];
                }



            });
        }
        // if (value) {
        // tslint:disable-next-line: max-line-length
        //     this.apiService.getUtilsInfoWithPrvID(this.apiUrl['getUtilsInfo'], this.apiUrl['state'], this.apiUrl['country'], value).subscribe(res => {

        //             this.addressStateList = res['state'];
        //             this.addResidencyState = res['state'];


        //     });
        // }

    }

    // On state change
    onStateChange(value: any, eventFrom: number) {


        if (value) {
            // tslint:disable-next-line: max-line-length
            this.apiService.getUtilsInfoWithPrvID(this.apiUrl['getUtilsInfo'], this.apiUrl['city'], this.apiUrl['state'], value).subscribe(res => {

                    this.addressCityList = res['city'];

            });
        }

    }

    // On city change
    onCityChange(value: any, eventFrom: number) {

        if (value) {

            // tslint:disable-next-line: max-line-length
            this.apiService.getUtilsInfoWithPrvIDInsurer(this.apiUrl['getUtilsInfo'], this.productType['tata-insurer-name'], this.productType['Tata-term'], this.apiUrl['pincode'], this.apiUrl['city'], value).subscribe(res => {

                    this.addressPincode = res['pincode'];
            });
        }

    }

    // City change end
    getcompanyList() {

        // tslint:disable-next-line: max-line-length
        this.apiService.getUtilsInfo(this.apiUrl['getUtilsInfo'], this.productType['tata-insurer-name'], this.productType['Tata-term'], this.apiUrl['company']).subscribe(res => {
            this.companyList = res['company'];


        });

    }


    /**
     * County display
     */

    travelInentionCountry(user?: CountryInfo): any | undefined {

        if (user) {
            return user ? user.master_name : undefined;
        }


    }

    travelOutsideCountry(user?: CountryInfo): any | undefined {

        if (user) {
            return user ? user.master_name : undefined;
        }


    }

    countryResidenceDisplay(user?: CountryInfo): any | undefined {

        if (user) {
            return user ? user.master_name : undefined;
        }


    }

    companyInfoDisplay(user?: CompanyInfo): any | undefined {

        if (user) {
            return user ? user.master_name : undefined;
        }


    }

    setFatcaData() {

        /**
         * check if fatca length avails
         */
        this.additonalFatcaArr = [];

        if ( this.fatcaQuestionnaireForm.get('addFatcaDetails').value.length) {

            this.dataToSend = {};

            this.fatcaQuestionnaireForm.get('addFatcaDetails').value.forEach((fatcaElement: any, fatcaID: number) => {

                if (fatcaElement) {


                    const data = {
                        id: fatcaElement['id'],
                        country_id: fatcaElement.addCountryTaxResidency,
                        tin_number: fatcaElement.taxIdentificationEquivalent,
                        tin_validity: this.datePipe.transform(new Date(fatcaElement.documentValidity), 'yyyy-MM-dd'),
                        tin_country_id: fatcaElement.numberIssueTINCountry,
                        address: {
                            building_name: fatcaElement.buildingName,
                            street_name: fatcaElement.streetName,
                            city: fatcaElement.cityName,
                            state: fatcaElement.stateName,
                            pincode: fatcaElement.fatcaPincode
                        }
                    };

                    this.finalvalToSend.push(data);
                    this.dataToSend = {};

                }

            });

            return this.additonalFatcaArr;

        }
    }

    /** Save Form data */

    saveQuestioniarieFormData(isValid: boolean , event) {

        if ( this.fatcaQuestionnaireForm.get('addFatcaDetails').value.length ) {
            this.fatcaValidation(true);
            this.setFatcaData();
        }

        // this.fatcaAsPerApi = this.setFatcaData();
        /**
         * get fatca information as per Api
         */



        if (isValid) {

            this.isLoaderActivated = true;

            const data = {

                    lifeassured: {
                        fatca_detail: {
                            place_of_birth: this.fatcaQuestionnaireForm.get('birthPlace').value ,
                            company_name: this.fatcaQuestionnaireForm.get('companyName').value ,
                            mobile: this.fatcaQuestionnaireForm.get('mobileNo').value ,
                            birth_country_id: this.fatcaQuestionnaireForm.get('birthCountry').value ,
                            // country_of_citizenship: this.fatcaQuestionnaireForm.get('citizenCountry').value ,
                            foreign_address: {
                                country_id: this.fatcaQuestionnaireForm.get('currentAddCountry').value ,
                                line_1: this.fatcaQuestionnaireForm.get('currentAddressLine1').value ,
                                line_2: this.fatcaQuestionnaireForm.get('currentAddressLine2').value ,
                                // line_3: this.fatcaQuestionnaireForm.get('currentAddCountry').value ,
                                // landmark: this.fatcaQuestionnaireForm.get('currentAddCity').value ,
                                city:  this.fatcaQuestionnaireForm.get('currentAddCity').value ,
                                state:  this.fatcaQuestionnaireForm.get('currentAddState').value ,
                                pincode_id: this.fatcaQuestionnaireForm.get('currentAddPincode').value ,
                            }
                        },
                        fatca_taxable_country_detail:   this.finalvalToSend
                    }

                };

            this.fatcaData = data;



        /**
         * deletion operation
         * if id has been deleted
         * in that sceanrio , deleted flag will be sent to system
         */
            // const deletedIndexList = [];
            // let objectFormation;

            // if ( this.previousPolicyData) {

            //     this.fatcaAsPerApi.forEach((elementData: any, indexObtained: number) => {

            //         if ( elementData ) {

            //             objectFormation = {
            //                 id: elementData['id'],
            //                 deleted: true
            //             };
            //         }

            //         deletedIndexList.push(objectFormation);

            //     });

            //     const mergedObjectInfo: any = {

            //         fatca_taxable_country_detail: deletedIndexList
            //     };

            //     this.fatcaData = [...mergedObjectInfo];

            // }

            this.finalDataToSend =  Object.assign({},  this.fatcaData);

                /** Invoking api serices -Update proposal */

            this.apiService.updateProposal(
                    this.apiUrl['apiV2LifeProposal'],
                    this.proposalId, this.uuid,
                    this.apiUrl['update_proposal'],
                    this.finalDataToSend).subscribe(res => {

                    if (res) {
                        this.isLoaderActivated = false;
                        if (this.tabListData && this.tabListData.length > 1) {

                            this.tabListData.forEach((element, index) => {
                                if (element['type'] === 'fatca') {

                                    if(index < (this.tabListData.length) - 1) {

                                        this.sharedData.getNextCrntActiveTab(this.tabListData[index + 1] , 0);
                                    } else {
                                        
                                        this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                                    }
                                }

                            });




                        } else {

                            this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                        }
                    }

                },
                    err => {
                        console.log('sonething went at our end', err);
                    });

         }
    }


    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });



        // Get propsoal info

        if (this.uuid && this.proposalId) {

            this.isLeftSectionLoader = true;

            this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
                if (res) {

                    this.proposalRes = res;


                    if (this.proposalRes) {

                    /**
                     * fetch docs
                     */

                    this.apiService.getDocumentUploadedData(
                        this.apiUrl['apiDocumentUpload'],
                        this.proposalId, this.uuid, this.apiUrl['fetch_docs']).subscribe(res => {
                        if (res) {

                            this.docProposalRes = res['docs'];


                            if (this.proposalRes &&  this.docProposalRes) {

                                this.feedProposalData();

                            }
                        }

                    });

                    }
                }

            });

          
            this.getOccupationUtilsInfo();
            this.getCountryList();
            this.getcompanyList();
            this.fatcaValidation(true);


        }
    }

    // filterCompanyName(valueObtained: string) {

    //     if (valueObtained) {

    //        const results =   this.companyList
    //           .map(group => ({master_name: group.master_name, id: group.id}))
    //           .filter(group => group.master_name.toLowerCase().indexOf(valueObtained) === 0);


    //        return results;
    //       }

    //     return this.companyList;

    // }

    /**
     * Back btn
     */



    backBtnFromPersonalDetails() {
        this.router.navigate(['/life/upload-document', this.proposalId, this.uuid])
        .then(() => {
            window.location.reload();
        });

    }



    createPrvInsCtrl(): FormGroup {

        /**
         * Assigning key same as backend to avoid matching key name
         */

        return this.formbuild.group({
            id : [''],
            addCountryTaxResidency: [''],
            jurisdictionTaxAddress: [''],
            taxIdentificationEquivalent: [''],
            numberIssueTINCountry: [''],
            documentValidity: [''],
            buildingName: [''],
            streetName: [''],
            cityName: [''],
            stateName: [''],
            fatcaPincode: ['']

         });

    }

    additionalFatcaDetails() {

        (this.fatcaQuestionnaireForm.controls['addFatcaDetails'] as FormArray).push(this.createPrvInsCtrl());

        this.fatcaValidation(true);


    }


    deleteFatca(num: number) {

        if (  this.previousPolicyData ) {

            this.previousPolicyData.forEach((elementData: any, indexObtained: number) => {


                if (num ===  indexObtained ) {

                    const data = {
                        id: elementData['id'],
                        deleted: true
                    };

                    this.dataToSend  = data;
                    this.previousPolicyData.splice(indexObtained, 1);
                }



            });
        }
        this.finalvalToSend.push( this.dataToSend );
        this.additonalFatcaArr.push( this.dataToSend);

        (this.fatcaQuestionnaireForm.controls['addFatcaDetails'] as FormArray).removeAt(num);


    }

    getOccupationUtilsInfo() {

        // tslint:disable-next-line: max-line-length
        this.apiService.getUtilsInfo(this.apiUrl['getUtilsInfo'], this.productType['tata-insurer-name'], this.productType['Tata-term'], this.apiUrl['occupation']).subscribe(res => {

            this.occupationList = res['occupation'];

        });
    }

    fatcaValidation(val: boolean) {

        /**
         * vdalidation on control lendth
         */


        for (const fatcaValidDetails of this.fatcaQuestionnaireForm.get('addFatcaDetails')['controls']) {

            if (val) {

                fatcaValidDetails.controls['addCountryTaxResidency'].setValidators([Validators.required]);
                // fatcaValidDetails.controls['jurisdictionTaxAddress'].setValidators([Validators.required, Validators.maxLength(150)]);
                fatcaValidDetails.controls['taxIdentificationEquivalent'].setValidators([Validators.required, Validators.maxLength(150)]);
                fatcaValidDetails.controls['numberIssueTINCountry'].setValidators([Validators.required, Validators.maxLength(100)]);
                fatcaValidDetails.controls['documentValidity'].setValidators(
                    [Validators.required]
                );

                fatcaValidDetails.controls['buildingName'].setValidators(
                    [Validators.required]
                );
                fatcaValidDetails.controls['streetName'].setValidators(
                    [Validators.required]
                );
                fatcaValidDetails.controls['cityName'].setValidators(
                    [Validators.required]
                );
                fatcaValidDetails.controls['stateName'].setValidators(
                    [Validators.required]
                );
                fatcaValidDetails.controls['fatcaPincode'].setValidators(
                    [Validators.required]
                );

            }

            if (!val) {


                fatcaValidDetails.controls['addCountryTaxResidency'].setValidators([]);
                fatcaValidDetails.controls['jurisdictionTaxAddress'].setValidators([]);
                fatcaValidDetails.controls['taxIdentificationEquivalent'].setValidators([]);
                fatcaValidDetails.controls['numberIssueTINCountry'].setValidators([]);
                fatcaValidDetails.controls['documentValidity'].setValidators([]);

                fatcaValidDetails.controls['buildingName'].setValidators(
                   []
                );
                fatcaValidDetails.controls['streetName'].setValidators(
                   []
                );
                fatcaValidDetails.controls['cityName'].setValidators(
                   []
                );
                fatcaValidDetails.controls['stateName'].setValidators(
                   []
                );
                fatcaValidDetails.controls['fatcaPincode'].setValidators(
                   []
                );


            }



            fatcaValidDetails.controls['addCountryTaxResidency'].updateValueAndValidity();
            fatcaValidDetails.controls['jurisdictionTaxAddress'].updateValueAndValidity();
            fatcaValidDetails.controls['taxIdentificationEquivalent'].updateValueAndValidity();
            fatcaValidDetails.controls['numberIssueTINCountry'].updateValueAndValidity();
            fatcaValidDetails.controls['documentValidity'].updateValueAndValidity();


            fatcaValidDetails.controls['buildingName'].updateValueAndValidity();
            fatcaValidDetails.controls['streetName'].updateValueAndValidity();
            fatcaValidDetails.controls['cityName'].updateValueAndValidity();
            fatcaValidDetails.controls['stateName'].updateValueAndValidity();
            fatcaValidDetails.controls['fatcaPincode'].updateValueAndValidity();

        }

    }

}
